function SaveJobIcon({
  color = "#040404",
  fill = "none",
  width = "20",
  height = "20",
}) {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 23 23"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1106_1844)">
        <mask
          id="mask0_1106_1844"
          style={{ maskType: "luminance" }} // ✅ Fixed JSX style format
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="23"
          height="24"
        >
          <path d="M0 -0.00103951H23V23.7656H0V-0.00103951Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1106_1844)">
          <path
            d="M5.00407 0.671877C4.62147 0.671877 4.25347 0.823803 3.98281 1.09482C3.71211 1.36547 3.56055 1.73248 3.56055 2.11535V21.3376C3.56055 21.8825 4.00083 22.3242 4.54573 22.3242H4.54937C4.84167 22.3242 5.11952 22.2081 5.32521 22.0016C6.28151 21.046 9.10355 18.224 10.2692 17.0605C10.594 16.734 11.0378 16.5503 11.4998 16.5503C11.9617 16.5503 12.4056 16.734 12.7303 17.0605C13.8995 18.2276 16.736 21.0634 17.6815 22.0103C17.8836 22.2113 18.1542 22.3242 18.4393 22.3242C18.9915 22.3242 19.4389 21.8771 19.4389 21.3253V2.11535C19.4389 1.73248 19.2874 1.36547 19.0167 1.09482C18.746 0.823803 18.378 0.671877 17.9954 0.671877H5.00407Z"
            stroke={`${color}`}
            strokeWidth="2" // ✅ Fixed camelCase
            strokeMiterlimit="10" // ✅ Fixed camelCase
            strokeLinecap="round" // ✅ Fixed camelCase
            strokeLinejoin="round" // ✅ Fixed camelCase
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1106_1844">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SaveJobIcon;
